// no-dd-sa:javascript-code-style/parameter-name,javascript-code-style/max-params
import { create } from 'apisauce';

import qs from 'qs';

export const api = create({
  baseURL: process.env.REACT_APP_API_ROOT,
  withCredentials: true,
});

export const dataorchApi = create({
  baseURL: process.env.REACT_APP_DATAORCH_API_ROOT,
  withCredentials: true,
});

export const driverApi = create({
  baseURL: process.env.REACT_APP_DRIVER_API_ROOT,
  withCredentials: true,
});

export const warehouseApi = create({
  baseURL: process.env.REACT_APP_WAREHOUSE_API_URL,
  withCredentials: true,
});

export const getUser = () => api.get(`/me`);
export const getTemplates = (params) => api.get(`/templates`, params);
export const getTemplate = (version) => api.get(`/templates/${version}`);
export const createTemplate = (data) => api.post(`/templates`, data);
export const getTemplateAllRegionETA = (data) => api.get(`/pickup-templates`, data);
export const getTemplateAllRegionETAPagination = (data) => api.get(`/pickup-templates/pagination`, data);
export const getTemplatePickupETA = (id) => api.get(`/pickup-templates/${id}`);
export const getTemplatePickupETADefault = (params) => api.get(`/pickup-templates/default-template`, params);
export const createPickupETA = (data) => api.post(`/pickup-templates/create`, data);
export const updatePickupETA = (template_id, data) => api.put(`/pickup-templates/${template_id}`, data);
export const getPickupETAEvent = (warehouse_id) => api.get(`/pickup-templates/events`, { warehouse_id });
export const downloadPDF = (data) =>
  api.post(`/templates/download/pdf`, data, {
    headers: { Accept: 'application/octet-stream' },
  });
export const getShipment = (shipmentId) => api.get(`/templates/shipments/${shipmentId}`);
export const previewTemplate = (params) => {
  const { uri, data, responseType } = params;

  return api.post(uri, data, responseType && { responseType });
};

export const listDsp = (params) => api.get('/dsp', params);
export const getDsp = (id) => api.get(`/dsp/${id}`);
export const postDsp = (data) => api.post('/dsp', data);
export const updateDsp = (id, params) => api.post(`/dsp/${id}`, params);
export const getCourierZones = (id) => api.get(`/dsp/${id}/zones`);
export const saveCourierZones = (id, region, data) => api.post(`/dsp/${id}/zones/${region}`, data);

export const listDspDriver = (params, courierId) => api.get(`/dsp/${courierId}/drivers`, params);
export const convertDriver = (driverId) => api.put(`/dsp/driver/${driverId}/convert`);
export const removeDriver = (courierId, driverId) => api.delete(`/dsp/drivers/${courierId}/${driverId}`);
export const getDriver = (driverId) => api.get(`/dsp/drivers/${driverId}`);
export const insertDriver = (courierId, params) => api.post(`/dsp/drivers/${courierId}`, params);
export const manuallyApprove = (driverId) => api.post(`/dsp/manually_approve/${driverId}`);
export const getDrivers = (params) => api.get(`/dsp/drivers`, params);

export const listClient = (params) => api.get('/clients', params);
export const listAllClients = (params) => api.get('/clients/all', params);
export const postClient = (data) => api.post('/clients', data);
export const listInsuranceProviders = () => api.get('/clients/insurance-providers');

export const getActiveClients = () => dataorchApi.get('/clients/active');
export const getActivePurchasers = () => dataorchApi.get('/clients/active-purchasers');
export const getRegionList = () => dataorchApi.get('/regions');

export const getClient = (clientId, includeSettings = true) => api.get(`clients/${clientId}?includeSettings=${includeSettings}`);
export const updateClientInfo = (clientId, data) => api.put(`clients/${clientId}/info`, data);
export const listClientSettings = (clientId) => api.get(`/clients/${clientId}/settings`);
export const updateClientSettings = (clientId, data) => api.post(`/clients/${clientId}/settings`, data);

export const listTelephone = (clientId) => api.get(`/clients/${clientId}/telephone`);
export const updateTelephones = (clientId, data) => api.post(`/clients/${clientId}/telephones`, data);

export const listShipments = (params) => api.get('/sms/shipments', params);
export const listShipmentsByAssignment = (params) => api.get('/sms/shipments/by_assignments', params);
export const sendSms = (data) => api.post('/sms/', data);
export const getEstimatedCost = (data) => api.post('/sms/estimated_cost', data);
export const getTemplateSms = (params) => api.get('/sms/templates', params);
export const saveTemplateSms = (data) => api.post('/sms/templates', data);

export const listWarehouse = (params) => api.get(`/warehouses`, params);
export const listWarehouseRegion = (params) => api.get(`/warehouses/regions`, params);
export const listExistClient = () => api.get(`/warehouses/clients`);
export const addWarehouse = (params) => api.post('/warehouses', params);
export const updateWarehouse = (params, id) => api.post(`/warehouses/${id}`, params);
export const detailWarehouse = (id) => api.get(`/warehouses/${id}`);
export const deleteWarehouse = (id) => api.delete(`/warehouses/${id}`);
export const getGeocode = (params) => api.get('/warehouses/geocode', params);
export const listUsers = (params) => api.get('/warehouses/users', params);
export const listWarehouseUsers = (warehouse_id, params) => api.get(`/warehouses/${warehouse_id}/users`, params);
export const addWarehouseUsers = (warehouse_id, user_ids) => api.post(`/warehouses/${warehouse_id}/users`, user_ids);
export const deleteWarehouseUser = (warehouse_id, user_id) =>
  api.delete(`/warehouses/${warehouse_id}/users/${user_id}`);

export const getWarehouseConfig = (id, { signal } = {}) => api.get(`/warehouses/${id}/config`, undefined, { signal });
export const updateWarehouseConfig = (id, data) => api.post(`/warehouses/${id}/config`, data);

export const listWarehousePrinters = (warehouse_id) => api.get(`/warehouses/${warehouse_id}/printers`);
export const addWarehousePrinter = (warehouse_id, printerInfos) =>
  api.post(`/warehouses/${warehouse_id}/printer`, printerInfos);
export const deleteWarehousePrinter = (printer_id) => api.delete(`/warehouses/printer/${printer_id}`);

export const createWarehouseLayout = (warehouse_id, data, update = false) =>
  warehouseApi.post(`/warehouse/${warehouse_id}/layout`, data, { params: { update } });
export const createWarehouseStorageConfig = (warehouse_id, data, update = true) =>
  warehouseApi.post(`/warehouse/${warehouse_id}/storage/config`, data, { params: { update } });
export const getWarehouseLayout = (warehouse_id) => warehouseApi.get(`/warehouse/${warehouse_id}/layout`);
export const getWarehouseStorageConfig = (warehouse_id) =>
  warehouseApi.get(`/warehouse/${warehouse_id}/storage/config`);

export const searchPrefix = (params) => api.get(`/prefix/search`, params);
export const addPrefix = (payload) => api.post(`/prefix/add`, payload);
export const editPrefix = (id, payload) => api.put(`/prefix/${id}/update`, payload);
export const deletePrefix = (id) => api.delete(`/prefix/${id}/delete`);
export const getZoneIds = (params) => api.get('/prefix/zone-ids', params);
export const getRouteTypes = () => api.get(`/prefix/configs`);
export const getPrefixDetail = (id) => api.get(`/prefix/${id}`);

export const loadMetricsData = (id, filter) => dataorchApi.post(`/metrics/chart/${id}/data`, filter);
export const loadCharts = (group) => dataorchApi.get(`/metrics/chart?group=${group}`);
export const loadChart = (id) => dataorchApi.get(`/metrics/chart/${id}`);

// users
export const searchUser = (keyword) => api.get(`/users/search?keyword=${keyword}`);
export const updatePassword = (id, data) => api.put(`/users/${id}/password`, data);

export const resetFailureCount = (user_id) => api.put(`/users/${user_id}/reset_failed_count`);

// maptools
export const insertMap = (data) => api.post('/map/tools', data);
export const getMap = (id) => api.get(`/map/tools?id=${id}`);

// jobs
export const getClients = () => api.get(`/jobs/clients`);
export const getJobs = (filters) => api.get(`/jobs`, filters);
export const getJobInfo = (jobId) => api.get(`/jobs/${jobId}/info`);
export const deleteJob = (jobId) => api.delete(`/jobs/${jobId}`);
// Pods
// export const getListPods = (params) => api.get(`/pods?${params}`);
// export const postPodsClassify = (params) => api.patch(`/pods`, params);

// delivery report
export const getExistReports = (request) =>
  dataorchApi.get(`/reports/${request.type}/exist`, { ...request, type: null });
export const getRecentReports = (type, limit) => dataorchApi.get(`/reports/${type}/recent`, { limit });
export const getReport = (id) => dataorchApi.get(`/reports/uploaded/${id}`);
export const requestReport = (request) => dataorchApi.post(`/reports/${request.type}/request`, request);

// comingled report
export const comingledReport = (data) => api.post('/report/comingled-report', data);

// Driver appeal
export const listDriverAppeals = (params) => dataorchApi.post(`/appeals/search`, params);
export const getDriverAppealsDetail = (appealId) => dataorchApi.get(`/appeals/${appealId}`);
export const getDriverAppealsComments = (appealId) => dataorchApi.get(`/appeals/${appealId}/comments`);
export const replyAppeal = (params) => dataorchApi.post('/appeals/comments', params);
export const updateAppealStatus = (appealId, status, payload) =>
  dataorchApi.put(`appeals/${appealId}/status/${status}`, payload);
export const appealFiles = (appealId) => dataorchApi.get(`/appeals/${appealId}/files`);

// Driver complaint
export const listDriverComplaints = (params) => dataorchApi.post(`/driver/complaint/all`, params);
export const listComplaintComments = (complaintId) => dataorchApi.get(`/driver/complaint/${complaintId}/comment`);
export const createComplaintComment = (complaintId, params) =>
  dataorchApi.post(`/driver/complaint/${complaintId}/comment`, params);
export const updateComplaintStatus = (complaintId, status) =>
  dataorchApi.put(`/driver/complaint/${complaintId}/status`, { status });
export const approveRejectComplaint = (complaintId, params) =>
  dataorchApi.put(`/driver/complaint/${complaintId}/approve_reject`, params);
export const resetNewDriverComment = (complaintId) =>
  dataorchApi.put(`/driver/complaint/${complaintId}/reset-new-driver-comment`);

// driver pricing
export const getAssignmentPricings = (params) => api.post('/drivers/simulation', params);
export const getRegions = () => api.get('/drivers/simulation/regions');
export const getAssignmentPricing = (params) => api.post('/drivers/simulation/assignments', params);
export const getAssignmentDistance = (id, params) => api.post(`/drivers/simulation/assignments/${id}`, params);

// Health benefit
export const listHealthBenefits = (params) => dataorchApi.post(`/health_benefit/search_health_benefit`, params);
export const updateHealthBenefitStatus = (id, status, params) =>
  dataorchApi.put(`/health_benefit/${id}/status/${status}`, params);
export const enableDisableAllHBR = (params) => dataorchApi.put(`/health_benefit/enable_all_health_benefit`, params);
export const enableDisableHBR = (params) => dataorchApi.put(`/health_benefit/enable_health_benefit`, params);

// Health benefit payment request
export const listHealthBenefitPaymentRequests = (params) =>
  dataorchApi.post(`/health_benefit/search_payment_request`, params);
export const updateHealthBenefitPaymentStatus = (id, status, params) =>
  dataorchApi.put(`/health_benefit/${id}/status/${status}`, params);
export const updateHealthBenefitRemark = (id, params) => dataorchApi.put(`/health_benefit/${id}/remark`, params);

// Drivers
export const listDrivers = (params) => dataorchApi.get('/drivers/search', params);
export const resignContract = (params) => dataorchApi.put('/drivers/resign-contract', params);

// Email log
export const listEmailLog = (params) => api.post(`/email-logs/search`, params);

export const assignmentFeedbacks = (params) => api.post(`/assignments/feedbacks`, params);

// forecast
export const getForecasts = (params) => api.get('/booking-forecasts', params);
export const getAdvanceBookingTemplates = () => api.get('/booking-templates');
export const getBookingTemplates = (params) => api.get('/booking-templates/list', params);
export const getForecast = (id) => api.get(`/booking-forecasts/${id}`);
export const getForecastFilterParams = () => api.get('/booking-forecasts/filter/params');

export const createForecast = (region, targetDate, name, description) =>
  api.post('/booking-forecasts', {
    region,
    target_date: targetDate,
    name,
    description,
  });

export const doUpdateForecast = (id, forecast) => api.put(`/booking-forecasts/${id}`, forecast);

// Forecast v2
export const getForecastRegions = () => dataorchApi.get('/booking/forecast/regions');

export const getForecastByRegion = (region) => dataorchApi.get(`/booking/forecast/regions/${region}`);

export const saveForecast = (data) => dataorchApi.put('/booking/forecast', data);

export const getForecastStatisticDataByRegion = (region) => dataorchApi.get(`/booking/forecast/regions/${region}/data`);

// Holiday settings
export const getHolidaySettingsByRegion = (region) => api.get(`/no-service-dates/${region}`);

export const updateHolidaySettingsByRegion = (region, data) => api.put(`/no-service-dates/${region}`, data);

// schedules
export const getScheduleItems = () => api.get(`/schedules`);
export const triggerSchedule = (id, item, fireTime) =>
  api.post(`/schedules/${id}/trigger`, item, {
    params: { fire_time: fireTime },
  });
// Formula
export const getFormulas = (params) => api.get('/formulas', params);
export const getFormula = (id) => api.get(`/formulas/${id}`);
export const createFormula = (formula) => api.post('/formulas', formula);
export const updateFormula = (id, formula) => api.put(`/formulas/${id}`, formula);

export const deleteFormula = (id) => api.delete(`/formulas/${id}`);
export const revertFormula = (id) => api.delete(`/formulas/${id}`);
export const evaluateFormula = (formula) => api.post(`/formulas/evaluate`, formula);

// SFTP job
export const listSftpJobs = (filters) => api.get(`/sftp-jobs`, filters);
export const getSftpJobDetail = (id) => api.get(`/sftp-jobs/${id}`);
export const listSftpJobShipments = (filters) => api.get(`/sftp-jobs/shipments`, filters);

export const getAllHistoryEvent = () => dataorchApi.get('/events/prefix/deleted?ref=true');
export const getHistoryEventById = (id) => dataorchApi.get(`/events/prefix/${id}`);
export const getCrewsByRegions = (regions) => dataorchApi.get(`driver-crews/list-crews?${regions}`);
export const getDriverCrewsByIds = (ids) => dataorchApi.get(`driver-crews/get-crews`, { ids });
export const addBookingTemplate = (payload) => api.post(`/booking-templates`, payload);
export const updateBookingTemplate = (id, payload) => api.put(`/booking-templates/${id}`, payload);
export const getBookingTemplateDetail = (id) => api.get(`/booking-templates/${id}`);
export const createBookingSession = (payload) => dataorchApi.post(`/tickets/booking-sessions/create`, payload);
export const checkExistsBookingSession = (regions, targetDate, timezone) =>
  dataorchApi.get(`booking/region/${regions}/date/${targetDate}?timezone=${timezone}`);

export const getShipmentDetail = (id) => dataorchApi.get(`/shipments/${id}`);
export const updateStatusPOD = (annotationId, payload, sendSms) =>
  api.put(`/shipment-annotation/${annotationId}/update-status`, payload, {
    params: { sendSms },
  });
export const getShipmentAnnotation = (query) =>
  api.get(
    `/shipment-annotation${qs.stringify(query, { skipNulls: true, addQueryPrefix: true, encode: false, arrayFormat: 'repeat' })}`,
  );
export const getShipmentAnnotationDetail = (podId) => api.get(`/shipment-annotation/${podId}`);
export const shipmentAnnotationSendSMS = (sid) => api.post(`/shipment-annotation/${sid}/send-sms`);
export const getClientDetails = (clientIds) => dataorchApi.get(`/clients/profile`, { client_profile_ids: clientIds });
export const getPODsThumbDown = (query) => api.get(`/shipment-annotation/thumb-down${query}`);
export const getPODThumbDownDetail = (podId) => api.get(`/shipment-annotation/pod/${podId}`);
export const getClientsProfile = () => dataorchApi.get('/clients/profiles');
export const getBilling = (payload) => api.get('/billing-dispositions', payload);
export const getClientSuccessOwner = () => api.get('/billing-dispositions/client-managements');
export const getBillingStatues = () => api.get('/billing/statuses');
export const approveBillingDisposition = (id, payload) => api.put(`/billing-dispositions/${id}/approve`, payload);
export const changeBillingDisposition = (id, payload) => api.put(`/billing-dispositions/${id}/change`, payload);
export const rejectBillingDisposition = (id, payload) =>
  api.put(`/billing-dispositions/${id}/ops-manager/reject`, payload);
export const getBillingDispositionHistory = (id) => api.get(`/billing-dispositions/${id}/history`);
export const downloadCsvBillingDisposition = (id) =>
  api.get(`/billing-dispositions/${id}/download-csv`, null, {
    headers: {
      Accept: '*/*',
    },
  });

// Parking QR codes (data-orchestrator). Super-admins see/download every warehouse;
// other roles are scoped to their warehouse_users server-side.
export const listWarehousesWithParking = () => dataorchApi.get('/parking/warehouses-with-spots');
export const downloadParkingQrPdf = (warehouseId) =>
  dataorchApi.get('/parking/download-spot-codes', { warehouse_id: warehouseId }, { responseType: 'blob' });
// Download the QR PDF for a specific set of spots (used right after cloning, to print only the new spots).
export const downloadParkingQrForSpots = (warehouseId, spotIds) =>
  dataorchApi.post(
    '/parking/download-spot-codes',
    { warehouse_id: warehouseId, spot_ids: spotIds },
    { responseType: 'blob' },
  );

// Parking config (data-orchestrator). Mutations are restricted to super-admin/admin/warehouse-manager and scoped to
// the caller's warehouse_users server-side; history is additionally readable by warehouse-staff.
// Active parking spots for a warehouse (no time/day filtering). distinct=true (default) dedupes by id for the
// clone-source picker; distinct=false returns every row of every spot for the View Spots inspector.
export const listParkingSpots = (warehouseId, distinct = true) =>
  dataorchApi.get('/parking/config/spots', { warehouse_id: warehouseId, distinct });
export const cloneParkingSpots = (body) => dataorchApi.post('/parking/config/clone-spots', body);
export const setParkingEnabled = (warehouseId, enabled) =>
  dataorchApi.post('/parking/config/enabled', null, { params: { warehouse_id: warehouseId, enabled } });
export const switchParkingMode = (warehouseId, mode) =>
  dataorchApi.post('/parking/config/mode', null, { params: { warehouse_id: warehouseId, mode } });
export const getParkingConfigHistory = (warehouseId, urlParams) =>
  dataorchApi.get('/parking/config/history', { warehouse_id: warehouseId, ...(urlParams || {}) });

export const getShipmentAnnotationByAI = (query) =>
  api.get(
    `/shipment-annotation/pod-reviews${qs.stringify(query, { skipNulls: true, addQueryPrefix: true, encode: false, arrayFormat: 'repeat' })}`,
  );

export const getConditions = () => api.get(`/shipment-annotation/condition-names`);

export const getShipmentAnnotationByStopId = (stopId) => api.get(`/shipment-annotation/stop/${stopId}`);

export const updatePODReviewConditions = (podReviewId, conditions) =>
  api.put(`/shipment-annotation/pod-reviews/${podReviewId}/conditions`, conditions);

export const getNotesBillingDisposition = (id) => dataorchApi.get(`/notes/${id}`);
export const addNoteBillingDisposition = (id, content) => dataorchApi.post(`/notes/${id}`, content);
export const editNoteBillingDisposition = (id, content) => dataorchApi.put(`/notes/${id}/edit`, content);

export const getReviewRate = (start_date, end_date) =>
  api.get(`/billing-dispositions/status-board/client-success`, { start_date, end_date });
export const getApprovalRate = (start_date, end_date) =>
  api.get(`/billing-dispositions/status-board/ops-manager`, { start_date, end_date });
export const getClientLookback = (type, region, inbound_blame) =>
  api.get(`/billing-dispositions/status-board/client-lookback`, { type, region, inbound_blame });

export const getClientSuccesses = (query) => api.get(`/client-managements${query}`);
export const createClientSuccess = (payload) => api.post(`/client-managements`, payload);
export const deleteClientSuccess = (id) => api.delete(`/client-managements/${id}`);
export const getUsers = () => dataorchApi.get(`/users/cs_manager_or_ops_manager`);
export const approveSendEmailToClient = (id, payload) => api.post(`/clients/${id}/approve-email`, payload);

export const getEventTemplate = (targets, owners) => dataorchApi.get('/event-template', { targets, owners });
export const getEvents = (eventId, urlParams) => dataorchApi.get(`/events/${eventId}/all`, urlParams);
export const getReportConfigs = (targets) => dataorchApi.get(`/reports`, { targets });
export const getEventsByCategoryAndType = (category, type, urlParams) =>
  dataorchApi.get(`/events/cat/${category}/type/${type}`, urlParams);

export const getDetectionRequests = (params) => api.get(`/detection-requests`, params);
export const updateDetectionRequest = (id, payload) => api.put(`/detection-requests/${id}`, payload);

export const getRedactCustomerData = (params) => api.get(`/redact-customer-data`, params);
export const createRedactCustomerData = (payload) => api.post(`/redact-customer-data`, payload);
export const getClientShipmentNumber = (id, params) => dataorchApi.get(`/clients/${id}/total-shipments`, params);

export const calculateNetTotal = (id, payload) => dataorchApi.put(`/health_benefit/${id}/net_amount`, payload);
export const getListDSPUser = (id) => api.get(`/dsp/${id}/users/list`);
export const approveUserID = (id) => api.post(`/dsp/users/${id}/approve`);
export const getUserType = () => dataorchApi.get('/couriers/list-dsp-acl-group');

export const getListClientService = (region) => api.get(`configuration/client-service/${region}`);
export const getPaymentConfigs = (region) => api.get(`configuration/payment/${region}`);

export const getListDirectBooking = (region) => api.get(`configuration/direct-booking/${region}`);
export const getListDriverMatch = (region) => api.get(`configuration/driver-match/${region}`);
export const getListBookingTemplate = (region) => api.get(`configuration/booking-template/${region}`);
export const getListAdvanceBooking = (region) => api.get(`configuration/advance-booking/${region}`);

export const getFeatureFlags = () => api.get('configuration/features');

export const getListIgnoreBookingTemplateByDate = (date) => api.get(`ignore-booking/list-by-date/${date}`);
export const addIgnoreBookingTemplate = (data) => api.post('ignore-booking/add', data);
export const removeIgnoreBookingTemplate = (id) => api.delete(`ignore-booking/${id}`);

export const getMetadata = (owner, scope) => dataorchApi.get(`/metadata/${owner}/${scope}`);

// Legal Documents
export const uploadLegalDocument = (formData) =>
  api.post('/legal-documents/contract-templates', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
export const getContractAgreements = (params) => api.get('/legal-documents/contract-agreements', params);
export const getContractAgreementRequests = (params) => api.get('/legal-documents/contract-agreement-requests', params);
export const getContractAgreementRequest = (id) => api.get(`/legal-documents/contract-agreement-requests/${id}`);
export const getLegalConfig = () => api.get('/legal-documents/configs');
export const getContractTemplates = (params) => api.get('/legal-documents/contract-templates', params);
export const createContractAgreementRequest = (data) => api.post('/legal-documents/contract-agreement-requests', data);
export const updateContractAgreementRequest = (id, data) =>
  api.put(`/legal-documents/contract-agreement-requests/${id}`, data);
export const getEmailTemplates = (params) => api.get('/email-templates', params);
export const updateEmailTemplate = (id, payload) => api.put(`/email-templates/${id}`, payload);

// Service Level Agreement APIs
export const getSlaIdentifierPresets = ({ signal } = {}) =>
  api.get('/service-level-agreements/identifiers', undefined, { signal });

// NOTE: As per ENA-720, SLAs are now versioned at the delivery region level.
// Each (client_id, injection_region, delivery_region) has its own version history.

/**
 * Get all SLA contracts (delivery region records) with pagination
 * Returns individual delivery region records, not grouped SLAs
 */
export const getServiceLevelAgreements = (params = {}) => {
  const queryParams = {
    page: params.page || 0,
    size: params.size || 20,
    order_by: params.orderBy || 'client_id',
    desc: params.desc || false,
    ...(params.searchQuery && { q: params.searchQuery }),
    ...(params.clientId && { client_id: params.clientId }),
    ...(params.slaIdentifier && { sla_identifier: params.slaIdentifier }),
    ...(params.activeOnly !== undefined && { active_only: params.activeOnly }),
  };

  return api.get('/service-level-agreements', queryParams);
};

/**
 * Get all active SLA contracts (delivery regions) for a specific client
 * Returns array of delivery region records
 */
export const getClientServiceLevelAgreements = (clientId) => api.get(`/service-level-agreements/${clientId}`);

/**
 * Get list of clients that have SLAs
 * @param {Object} params - Query parameters
 * @param {number} params.page - Page number (0-based)
 * @param {number} params.size - Page size
 * @param {string} params.order_by - Sort field
 * @param {boolean} params.desc - Sort direction
 * @param {string} params.q - Filter value
 * @param {string} params.filter_type - Filter type: 'sla_identifier', 'client_id', 'client_name', 'company'
 */
export const getClientsWithSlas = (params = {}) => {
  const queryParams = {
    page: params.page || 0,
    size: params.size || 20,
    order_by: params.order_by || 'client_name',
    desc: params.desc || false,
    ...(params.q && { q: params.q }),
    ...(params.filter_type && { filter_type: params.filter_type }),
  };

  return api.get('/service-level-agreements/clients', queryParams);
};

/**
 * Get all active delivery region SLAs for a client and injection region
 * Returns array of delivery region records (one per delivery region)
 */
export const getSLAByClientAndRegion = (clientId, injectionRegion, slaIdentifier = 'default') => {
  return api.get(
    `/service-level-agreements/${clientId}/injection-region/${injectionRegion}/sla-identifier/${slaIdentifier}`,
  );
};

/**
 * Create a new SLA contract (delivery region record)
 * Data should include: client_id, injection_warehouse_region, delivery_region, days, effective_start_date, etc.
 */
export const createServiceLevelAgreement = (data) => api.post('/service-level-agreements', data);

/**
 * Update an existing SLA contract by ID
 * Note: effective_start_date and version are immutable after creation
 */
export const updateServiceLevelAgreement = (slaId, data) => api.put(`/service-level-agreements/id/${slaId}`, data);

/**
 * Delete an SLA (all delivery regions for a client/injection region/sla identifier)
 */
export const deleteServiceLevelAgreement = (clientId, region, contractNumber, slaIdentifier = 'default') =>
  api.delete(
    `/service-level-agreements/${clientId}/injection-region/${region}/sla-identifier/${slaIdentifier}?contract_number=${contractNumber}`,
  );

/**
 * Add or update a delivery region SLA (creates a new version if one exists)
 * This will automatically:
 * - Set effective_end_date of prior version to new_start_date - 1 second
 * - Increment version number
 * - Create new record with version = maxVersion + 1
 */
export const addOrUpdateRegionSLADays = (clientId, data) =>
  api.post(`/service-level-agreements/${clientId}/sla-days`, data);
/**
 * Remove a delivery region SLA (sets effective_end_date to now)
 * Uses DELETE with request body as expected by backend
 */
export const removeRegionSLADays = (clientId, injectionRegion, deliveryRegion, slaIdentifier = 'default') =>
  api.delete(
    `/service-level-agreements/${clientId}/sla-days`,
    {},
    {
      data: {
        regionCode: deliveryRegion,
        injectionRegion: injectionRegion,
        slaIdentifier: slaIdentifier,
      },
    },
  );

/**
 * Get version history for a specific delivery region
 * Returns all versions (active and historical) for (client, injection_region, delivery_region, sla_identifier)
 */
export const getDeliveryRegionVersionHistory = (
  clientId,
  injectionRegion,
  deliveryRegion,
  slaIdentifier = 'default',
) => {
  return api.get(
    `/service-level-agreements/${clientId}/injection-region/${injectionRegion}/delivery-region/${deliveryRegion}/sla-identifier/${slaIdentifier}/versions`,
  );
};

/**
 * Create a new version of a delivery region SLA
 * Automatically sets effective_end_date of current active version
 */
export const createDeliveryRegionVersion = (
  clientId,
  injectionRegion,
  deliveryRegion,
  data,
  slaIdentifier = 'default',
) => {
  return api.post(
    `/service-level-agreements/${clientId}/injection-region/${injectionRegion}/delivery-region/${deliveryRegion}/sla-identifier/${slaIdentifier}/versions`,
    data,
  );
};

/**
 * Cancel a scheduled (future) version of a delivery region SLA
 * This deletes a version that has not yet become active (effective_start_date is in the future)
 *
 * @param {string} clientId - Client ID
 * @param {string} injectionRegion - Injection warehouse region
 * @param {string} deliveryRegion - Delivery region
 * @param {number} version - Version number to cancel (e.g., 1, 2, 3)
 * @param {string} slaIdentifier - SLA identifier (default: 'default')
 */
export const cancelScheduledVersion = (
  clientId,
  injectionRegion,
  deliveryRegion,
  version,
  slaIdentifier = 'default',
) => {
  return api.delete(
    `/service-level-agreements/${clientId}/injection-region/${injectionRegion}/delivery-region/${deliveryRegion}/sla-identifier/${slaIdentifier}/versions/${version}`,
  );
};

/**
 * Directory Map Image Review APIs
 */

/**
 * List directory map image reviews with pagination, search and filter
 * @param {Object} params - Query parameters (page, size, statuses, driver_ids, order_by, desc)
 */
export const getDirectoryMapImageReviews = (params) => api.get('/directory-maps', params);

/**
 * Review (approve/reject) a directory map image
 * @param {string} id - The review item UUID
 * @param {Object} payload - { status: 'APPROVED' | 'REJECTED', note?: string }
 */
export const reviewDirectoryMapImage = (id, payload) => api.put(`/directory-maps/${id}`, payload);
